"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FIXED_COLUMNS = void 0;

/**
 * 发货管理 - 第一表格表头字段配置
 * 按顺序定义，key 对应 materialData JSON 字段名，label 为显示名称
 */
// 固定列（模板中硬编码，不参与动态渲染）
var FIXED_COLUMNS = [{
  key: 'expander',
  label: ''
}, {
  key: 'actions',
  label: '操作'
}]; // 动态列（按展示顺序排列）

exports.FIXED_COLUMNS = FIXED_COLUMNS;
var columns = [{
  key: 'initiatedPackages',
  label: '已发起包数',
  width: 90
}, {
  key: 'uninitiatedPackages',
  label: '未发起包数',
  width: 90
}, {
  key: 'unshippedPackages',
  label: '未出库包数',
  width: 90
}, {
  key: 'shippedPackages',
  label: '已出库包数',
  width: 90
}, {
  key: 'waitDuration',
  label: '已等待时长',
  width: 120
}, {
  key: 'reserveCountdown',
  label: '预约倒计时',
  width: 90
}, {
  key: 'visitCountdown',
  label: '上门倒计时',
  width: 90
}, // { key: 'remainingDistance', label: '剩余距离（km）', width: 120 },
{
  key: 'sendNumber',
  label: '发货单号',
  width: 140
}, {
  key: 'statusTag',
  label: '发货单状态',
  width: 90
}, {
  key: 'dealerShopName',
  label: '专卖店',
  width: 100
}, {
  key: 'contractNo',
  label: '合同号',
  width: 120
}, {
  key: 'orderNo',
  label: '订单号',
  width: 140
}, {
  key: 'orderType',
  label: '订单类型',
  width: 140
}, {
  key: 'custName',
  label: '客户姓名',
  width: 120
}, {
  key: 'phone',
  label: '客户电话',
  width: 120
}, {
  key: 'custAddress',
  label: '客户地址',
  width: 200
}, {
  key: 'salesman',
  label: '销售员',
  width: 100
}, {
  key: 'designer',
  label: '设计师',
  width: 100
}, {
  key: 'volume',
  label: '柜数',
  width: 70
}, {
  key: 'signDate',
  label: '签单日期',
  width: 140
}, {
  key: 'confirmPlanTime',
  label: '方案确认日期',
  width: 140
}, {
  key: 'contractAgreedDays',
  label: '合同约定工期(天)',
  width: 140
}, {
  key: 'contractAgreedPeriod',
  label: '合同约定工期',
  width: 140
}, {
  key: 'contractAmount',
  label: '合同金额',
  width: 100
}, {
  key: 'receivedAmount',
  label: '已收金额',
  width: 100
}, {
  key: 'unreceivedAmount',
  label: '未收金额',
  width: 100
}, {
  key: 'paymentRatio',
  label: '收款比例',
  width: 90
}, {
  key: 'productName',
  label: '产品名称',
  width: 100
}, {
  key: 'color',
  label: '板材花色',
  width: 140
}, {
  key: 'stone',
  label: '石材材料',
  width: 100
}, {
  key: 'stoneColor',
  label: '石材颜色',
  width: 100
}, {
  key: 'basinSource',
  label: '水盆来源',
  width: 90
}, {
  key: 'basinQuantity',
  label: '水盆数量',
  width: 90
}, {
  key: 'basinModel',
  label: '水盆型号',
  width: 100
}, {
  key: 'faucetSource',
  label: '龙头来源',
  width: 90
}, {
  key: 'faucetQuantity',
  label: '龙头数量',
  width: 90
}, {
  key: 'faucetModel',
  label: '龙头型号',
  width: 100
}, {
  key: 'orderTime',
  label: '下单时间',
  width: 110
}, {
  key: 'approveOrderTime',
  label: '审图时间',
  minWidth: 160
}, {
  key: 'dismantleTime',
  label: '拆单时间',
  minWidth: 160
}, {
  key: 'approveQuoteTime',
  label: '报价时间',
  minWidth: 160
}, {
  key: 'approveFinanceTime',
  label: '经销商确认时间',
  minWidth: 160
}, {
  key: 'receiveTime',
  label: '财务审核时间',
  minWidth: 160
}, {
  key: 'palnProductionTime',
  label: '排生产计划时间',
  minWidth: 160
}, {
  key: 'shipmentDatePromise',
  label: '承诺交货日期',
  minWidth: 160
}, {
  key: 'productionStartDateTime',
  label: '开始生产日期',
  minWidth: 160
}, {
  key: 'completeSetDate',
  label: '齐套入库时间',
  minWidth: 160
}, {
  key: 'productionStatus',
  label: '订单状态',
  minWidth: 100
}, {
  key: 'actualOutTime',
  label: '出库时间',
  minWidth: 160
}, {
  key: 'totalArea',
  label: '总面积',
  minWidth: 100
}, {
  key: 'expandArea',
  label: '展开面积',
  minWidth: 100
}, {
  key: 'stoneLeng',
  label: '房门面积',
  minWidth: 100
}, {
  key: '',
  label: '台面米数',
  minWidth: 100
}, {
  key: 'totalPack',
  label: '总包数',
  minWidth: 100
}, {
  key: 'inPack',
  label: '入库包数',
  minWidth: 100
}, {
  key: 'warehouse',
  label: '仓库',
  minWidth: 100
}, {
  key: 'storage',
  label: '库位',
  minWidth: 100
}, {
  key: 'initiator',
  label: '发起人',
  width: 110
}, {
  key: 'initiateTime',
  label: '发起时间',
  width: 140
}, {
  key: 'sendWay',
  label: '发货方式',
  width: 120
}, {
  key: 'bigHome',
  label: '大家居',
  width: 90
}, {
  key: 'visitDate',
  label: '上门日期',
  width: 110
}, {
  key: 'visitTime',
  label: '上门时间',
  width: 110
}, {
  key: 'consignee',
  label: '收货人',
  width: 100
}, {
  key: 'consigneePhone',
  label: '收货电话',
  width: 120
}, {
  key: 'consigneeAddress',
  label: '收货地址',
  width: 300
}, {
  key: 'vehicle',
  label: '车辆',
  width: 100
}, {
  key: 'driverName',
  label: '司机姓名',
  width: 150
}, {
  key: 'driverPhone',
  label: '司机电话',
  width: 120
}, {
  key: 'entryMethod',
  label: '进门方式',
  width: 100
}, {
  key: 'remark2',
  label: '备注',
  width: 150
}, {
  key: 'attachment',
  label: '附件',
  width: 100
}, {
  key: 'reservationPerson',
  label: '预约人',
  width: 110
}, {
  key: 'reservationTime',
  label: '预约时间',
  width: 140
}, {
  key: 'reservationTimeliness',
  label: '预约及时性',
  width: 100
}, {
  key: 'pickupPerson',
  label: '提货人',
  width: 110
}, {
  key: 'pickupTime',
  label: '提货时间',
  width: 140
}, {
  key: 'loadingCompleteImg',
  label: '装车完成图',
  width: 110
}, {
  key: 'checkInPerson',
  label: '签到人',
  width: 110
}, {
  key: 'checkInTime',
  label: '签到时间',
  width: 140
}, {
  key: 'arrivalTimeliness',
  label: '到达及时性',
  width: 100
}, {
  key: 'deliveryPerson',
  label: '送达人',
  width: 110
}, {
  key: 'deliveryTime',
  label: '送达时间',
  width: 140
}, {
  key: 'deliveredPackages',
  label: '送达包数',
  width: 90
}, {
  key: 'siteCheckImg',
  label: '现场检查图',
  width: 110
}, {
  key: 'siteCheckVideo',
  label: '现场检查视频',
  width: 110
}, {
  key: 'deliveryCompleteImg',
  label: '送货完成图',
  width: 110
}, {
  key: 'deliveryReceipt',
  label: '送货单',
  width: 100
}, {
  key: 'accountingPerson',
  label: '核算人',
  width: 110
}, {
  key: 'accountingTime',
  label: '核算时间',
  width: 140
}, {
  key: 'deliveryCommission',
  label: '送货提成',
  width: 90
}, {
  key: 'bigHomeInstallCommission',
  label: '大家居安装提成',
  width: 120
}, {
  key: 'floorCarryCount',
  label: '扛楼层数',
  width: 90
}, {
  key: 'otherCommission',
  label: '其它提成',
  width: 90
}, {
  key: 'accountingRemark',
  label: '备注',
  width: 150
}, {
  key: 'expectedPickupDate',
  label: '期望提货日期',
  width: 120
}, {
  key: 'expectedPickupTime',
  label: '期望提货时间',
  width: 140
}, // { key: 'loadingSequence', label: '装车顺序', width: 90 },
{
  key: 'auditPerson',
  label: '审核人',
  width: 110
}, {
  key: 'auditTime',
  label: '审核时间',
  width: 140
}, {
  key: 'shipper',
  label: '发货人',
  width: 110
}, {
  key: 'shipTime',
  label: '发货时间',
  width: 140
}, {
  key: 'shipList',
  label: '发货清单',
  width: 100
}, {
  key: 'courierCompany',
  label: '寄件公司',
  width: 100
}, // { key: 'collectionTime', label: '揽收时间', width: 140 },
{
  key: 'logisticsNo',
  label: '物流单',
  width: 140
}, // { key: 'trackingNo', label: '寄件单号', width: 140 },
// { key: 'shippingFee', label: '寄件费用', width: 100 },
{
  key: 'collectionImg',
  label: '揽收图',
  width: 100
}, // { key: 'shippingProgress', label: '寄件进度', width: 100 },
// { key: 'signTime', label: '签收时间', width: 140 },
{
  key: 'expectedDeliveryDate',
  label: '期望发货日期',
  width: 120
}, {
  key: 'expectedDeliveryTime',
  label: '期望发货时间',
  width: 140
}]; // 导出带排序字段

var _default = columns.map(function (col, index) {
  return {
    key: col.key,
    label: col.label,
    width: col.width,
    visible: true,
    sort: index
  };
});

exports.default = _default;